exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-modal-container {\r\n  padding: 15px;\r\n}\r\n\r\n.custom-modal-header {\r\n  background-color: #219161;\r\n  color: #fff;\r\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);\r\n  margin-top: -15px;\r\n  margin-bottom: 40px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/frames/flight-provider-info/flight-provider-info.component.css
// module id = ../../../../../src/app/main/frames/flight-provider-info/flight-provider-info.component.css
// module chunks = main